import { getRowBackgroundByBase, getStatusBadgeColorByBase } from '@/styles/projectColorTokens';

/** Цвета бейджа типа файла в попапе (фон строки статуса / токены). */
export function getProjectFileTypeBadgeColors(
  fileType: string
): { bg: string; color: string } | null {
  switch (fileType) {
    case 'Правки':
      return getStatusBadgeColorByBase('Правки');
    case 'Сэмпл':
      return getStatusBadgeColorByBase('Готов');
    case 'Глоссарий':
      return getStatusBadgeColorByBase('Проверка');
    case 'Текст':
      return {
        bg: 'var(--project-file-type-text-badge-bg)',
        color: 'var(--project-file-type-text-badge-fg)',
      };
    default:
      return null;
  }
}

/** Заливка кружка в подменю — та же визуальная плотность/прозрачность, что и фон бейджа типа. */
export function getProjectFileTypeMenuDotColor(type: string): string {
  switch (type) {
    case 'Текст':
      return 'var(--project-file-type-text-badge-bg)';
    case 'Правки':
      return getRowBackgroundByBase('Правки');
    case 'Сэмпл':
      return getRowBackgroundByBase('Готов');
    case 'Глоссарий':
      return getRowBackgroundByBase('Проверка');
    default:
      return getRowBackgroundByBase('Добавлен');
  }
}
